<template>
  <div class="yellow-banner-container">
    <div class="info-icon">
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAACiUlEQVRIibXWMWiUSRQH8N9+q4VBjusEvZCthOAVwk6ZyuYaudIiHJgmEFvLGAiCl/KaKxK0CkiKlEcqC6uUU9hI4CqDKKQTi1jIEot5Hztusrvh3PvDMDvzvfn/d2bevPc6/X7fFNzAA9zDXcyjiwHe4w1eYz/nfDKJqDNBbAFP8UeQT8MAL7GZcz6+yKAZs3ANR3g4InSGD3gb/Vn1rRv2RymltcuIdfEc27gWc1+xi99wHb/g1+ivx/xu2Il12yml5yml705kVGwbq9X4ALexglc4HbE/zTm/yjmvhN1B9W01+C4UWxsR2sDveOcSyDm/C/uNWrA+0tZBFpQ7ao9uA3+O4a3FeznncwYppSd4FsMvWMw5H7c7e1oJHWBrwiYWqjYOW4ZHei34dfr9/g3Fs7rKJd82+ejqbxfuDFJKPfyLq8qzuNUoD7b1mr0pQtCr2ljEHe7FsIsHjRIZWuyNLvpB1Hz3GiUEUR7o4SUIzqo2DYeV3d1GiXXw0fl39EPIOZ8GL8w3hvf1eZZCFT5F320UT4Gf/iexn6MfNEqagJuYm6VKSmkueOF9o+Qj6GBplmLB14nfbxol8bVYnrFYzfe6wb7hvS2b8lgvi4ggrdgA+w1OlAxLCS1/G279vwp1gudqTL3MOZ+0gXhTic5wH+sTuI6rNg7rwSN4N+FKRfDYMNm16WHL+UjRG6cQO1qv1sPjtiapk+cOXlTjZ/hnEvmIUC/sa6EXOeeddnBlZM2j6NuMfV+pMfaiHfo+pM2llJYUR1g2vCPxxx9V47Gl3Br+MkyoLc6UWPdJiQw3nXemL8rR7YzMjy3ldrCoVE2Dar6DW7gTfS00CPvFi4SYXKS2mFlF/A0ORbRyIW4PHgAAAABJRU5ErkJggg=="
        alt="info"
      />
    </div>
    <div class="yellow-banner-text">
      <span v-html="content"> </span>
    </div>
    <div class="close-icon">
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAlBJREFUSA21Vj1MFEEUfg8uwc49K8RiV46SRErE4hISC5FEY4deBY2NibUKBjDEaGMp0hLtjCSIjZ6hECksMLlScLcSq1s6qcb3ze5sZv/uxAtb3Mx735vve7vzZt4xdXlGPG9RKTVJxKMS6sThIZFqMXPzh+8/7kTBZWDNvbgpJNfL8LSf3+8HP6fTvsjKCQx73l1W9ELggaIFHXzHiun+ge+/tGP6baPmuktM/Ex8Fdv/j/OKZDt9zjnb3z46+mzWJAI684jcYP85cr1adX63w/AbCJJPVHO9P2Kf9LOUJXG8H/hnAPbhJ9rQPPng+UGSQHY9F2Gp5/LEBD1cmCeppJQ/NgZizkigqFpA/mV3V69ubm+nREC+/uY1z87N8eKT5RKRqAI5qnNayKaBzLO+yXpdDQ1d0OQ2trb6Sj1dWbFdei4vt1SJD1EOBBkyt4GsbbAPW1tmmhrBLXugT2gKgBH4AUEkB2Qct27cVN/39jJeY/IoNtkcf+NNxm4inck1jaOrKGEsmDhOtcAbucKwXYoZAAJycRU/l8bG6O3Gu9Q+2JHZ6rKxeB6KgGoVANSN3KzpLKJafbhyTbA9Xpuask09b8zcVkUbX1Zd4NavL9dErlpwQnGI7jQaOgbkX3d2tBBOtk16ZXxcHf46zCWEsxQLFN/9EHkw/4iaHz+RITcsRqSMXMpf94hkA0/1skNWaBYmu15HmyvpB7i/0Szk1eq9CajlgyB4bjgSATjQidAs5LtdFfOkXQ0t855NDs5kD2DYz6k1fVsE817/tvwFv67bJXHWByAAAAAASUVORK5CYII="
        alt="info"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "YellowBanner",

  props: {
    content: String,
  },
};
</script>

<style lang="scss" scoped>
.yellow-banner-container {
  position: relative;
  width: 100%;
  max-width: 1140px;
  max-height: 85px;
  display: flex;
  background-color: $secondary;
  box-shadow: -1px 1px 2px 0 rgb(0 0 0 / 30%);
  padding: 1.2em;
}

.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3em;
}

.close-icon {
  width: 3em;
  position: absolute;
  top: 10;
  right: 0;
}

.yellow-banner-text {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  max-width: 83.33%;
  padding: 0 12px;

  > span {
    font-size: 1.125em;
    font-weight: 700;
  }
}
</style>
